/** Texts for the salon setup screens (M1). Dutch is leading; English mirrors every key. */
export const setupNl = {
  'common.save': 'Opslaan',
  'common.saved': 'Opgeslagen',
  'common.cancel': 'Annuleren',
  'common.delete': 'Verwijderen',
  'common.close': 'Sluiten',
  'common.add': 'Toevoegen',
  'common.moreOptions': 'Meer opties',
  'common.fewerOptions': 'Minder opties',
  'common.back': 'Salon',
  'common.minutes': 'min',
  'common.hour': 'u',
  'common.none': 'Geen',
  'common.loading': 'Laden…',
  'day.1': 'Maandag',
  'day.2': 'Dinsdag',
  'day.3': 'Woensdag',
  'day.4': 'Donderdag',
  'day.5': 'Vrijdag',
  'day.6': 'Zaterdag',
  'day.7': 'Zondag',
  'aside.services': 'Zo zien klanten je diensten',
  'aside.offline': '{n} alleen in de agenda, niet online te boeken',
  'aside.offlineOne': '1 alleen in de agenda, niet online te boeken',
  'aside.from': 'vanaf',
  'aside.hours': 'Zo staat het op je boekingspagina',
  'aside.closures': 'Komende sluitingen',
  'aside.noClosures': 'Geen sluitingen gepland.',
  'aside.booking': 'Zo ziet je boekingspagina eruit',
  'aside.bookingOff': 'Online boeken staat uit. Klanten zien hier je telefoonnummer.',
  'aside.who': 'Bij wie?',
  'aside.anyone': 'Maakt niet uit',
  'aside.email': 'Zo ziet de e-mail eruit',
  'aside.business': 'Zo zien klanten je gegevens',
  'aside.onBooking': 'Op je boekingspagina',
  'aside.inEmails': 'Onder elke e-mail',
  'aside.teamWeek': 'Deze week',
  'aside.teamWeekHint': 'Werktijden van iedereen, zoals ze in de agenda staan.',
  'aside.help': 'Goed om te weten',
  'aside.read': 'Lees verder',
  'hours.open': 'Open',
  'hours.closed': 'Gesloten',
  'hours.notWorking': 'Vrij',
  'hours.addBlock': 'Tijdblok toevoegen',
  'hours.removeBlock': 'Tijdblok verwijderen',
  'hours.copyToWeekdays': 'Kopieer naar alle open dagen',
  'hoursPage.title': 'Openingstijden',
  'hoursPage.intro': 'Wanneer je salon open is. Online boeken kan alleen binnen deze tijden.',
  'hoursPage.holidays': 'Feestdagen',
  'hoursPage.holidaysIntro': 'Zet aan op welke feestdagen je dicht bent. Dit geldt elk jaar.',
  'hoursPage.closedOn': 'Gesloten',
  'hoursPage.closures': 'Sluitingsdagen',
  'hoursPage.closuresIntro': 'Vakantie of verbouwing? Klanten zien je bericht op je boekingspagina.',
  'hoursPage.from': 'Van',
  'hoursPage.until': 'Tot en met',
  'hoursPage.message': 'Bericht voor klanten (optioneel)',
  'hoursPage.messagePlaceholder': 'We zijn met vakantie',
  'hoursPage.noClosures': 'Geen sluitingsdagen gepland.',
  'services.title': 'Diensten',
  'services.intro': 'Wat klanten bij je kunnen boeken, met duur en prijs.',
  'services.empty.title': 'Nog geen diensten',
  'services.empty.body': 'Begin met een voorbeeldmenu voor jouw soort zaak en pas het aan, of maak zelf je eerste dienst.',
  'services.useTemplate': 'Gebruik voorbeelddiensten',
  'services.startEmpty': 'Zelf beginnen',
  'services.newService': 'Dienst',
  'services.newCategory': 'Categorie',
  'services.categoryName': 'Naam van de categorie',
  'services.renameCategory': 'Categorie wijzigen',
  'services.editCategory': 'Wijzigen',
  'services.deleteCategory': 'Categorie verwijderen',
  'services.deleteCategoryConfirm': 'Weet je het zeker? De diensten in deze categorie worden ook verwijderd. Bestaande afspraken blijven staan.',
  'services.from': 'vanaf',
  'services.variants': '{n} varianten',
  'services.variant1': '1 variant',
  'service.defaultVariant': 'Standaard',
  'services.notOnline': 'niet online',
  'service.new': 'Nieuwe dienst',
  'service.edit': 'Dienst bewerken',
  'service.name': 'Naam',
  'service.category': 'Categorie',
  'service.duration': 'Duur',
  'service.price': 'Prijs',
  'service.priceHint': 'Inclusief btw, zoals klanten het zien.',
  'service.fromPrice': 'Vanaf-prijs',
  'service.fromPriceHint': 'Klanten zien "vanaf € …", bijvoorbeeld als de prijs afhangt van de haarlengte.',
  'service.description': 'Omschrijving voor klanten',
  'service.processing': 'Inwerktijd',
  'service.processingHint': 'Tijdens de inwerktijd ben jij vrij voor een andere klant, bijvoorbeeld terwijl kleuring inwerkt.',
  'service.before': 'Eerst werken',
  'service.wait': 'Inwerken',
  'service.after': 'Daarna werken',
  'service.cleanup': 'Opruimtijd na afloop',
  'service.cleanupHint': 'Tijd om op te ruimen. Klanten zien dit niet, maar er wordt niets direct na geboekt.',
  'service.variants': 'Varianten',
  'service.variantsHint': 'Bijvoorbeeld kort, halflang of lang haar, elk met een eigen duur en prijs. De klant kiest er een.',
  'service.addVariant': 'Variant toevoegen',
  'service.variantName': 'Naam variant',
  'service.who': 'Wie kan dit',
  'service.everyone': 'Iedereen',
  'service.online': 'Online boekbaar',
  'service.onlineHint': 'Uit: alleen jij en je team kunnen dit inplannen.',
  'service.vat': 'Btw-tarief',
  'service.vatHint': 'Alleen voor je overzichten. Kappers en barbiers: 9%. Nagels, schoonheid, pedicure, massage: 21%.',
  'service.delete': 'Dienst verwijderen',
  'service.deleteConfirm': 'Dienst verwijderen? Bestaande afspraken blijven staan.',
  'team.title': 'Team',
  'team.intro': 'Wie er bij je werkt, wanneer, en wat ze kunnen.',
  'team.add': 'Teamlid toevoegen',
  'team.followsHours': 'Volgt openingstijden',
  'team.ownHours': 'Eigen werktijden',
  'team.owner': 'Eigenaar',
  'team.manager': 'Manager',
  'team.staff': 'Medewerker',
  'team.noLogin': 'Geen app-toegang',
  'member.new': 'Nieuw teamlid',
  'member.name': 'Naam',
  'member.nameHint': 'Zo zien klanten deze persoon op je boekingspagina.',
  'member.color': 'Kleur in de agenda',
  'member.online': 'Online boekbaar',
  'member.onlineHint': 'Uit: klanten kunnen deze persoon niet online kiezen en krijgen hem of haar niet automatisch toegewezen.',
  'member.services': 'Diensten',
  'member.allServices': 'Alle diensten',
  'member.hours': 'Werktijden',
  'member.hoursFollow': 'Werkt wanneer de salon open is',
  'member.hoursOwn': 'Eigen werktijden',
  'member.blocked': 'Geblokkeerde tijd',
  'member.blockedIntro': 'Pauze, vrije dag, ziek of vakantie. Deze tijd is niet online te boeken.',
  'member.noBlocks': 'Geen geblokkeerde tijd gepland.',
  'member.sickToday': 'Ziek melden voor vandaag',
  'member.delete': 'Teamlid verwijderen',
  'member.deleteConfirm': 'Teamlid verwijderen? Bestaande afspraken blijven staan.',
  'block.add': 'Tijd blokkeren',
  'block.date': 'Datum',
  'block.allDay': 'Hele dag',
  'block.from': 'Van',
  'block.until': 'Tot',
  'block.reason': 'Reden',
  'block.repeat': 'Herhalen',
  'block.repeatNone': 'Niet',
  'block.repeatDaily': 'Elke dag',
  'block.repeatWeekly': 'Elke week',
  'block.repeatUntil': 'Herhalen tot en met',
  'reason.pause': 'Pauze',
  'reason.day_off': 'Vrij',
  'reason.sick': 'Ziek',
  'reason.vacation': 'Vakantie',
  'reason.meeting': 'Overleg',
  'reason.other': 'Anders',
  'business.title': 'Bedrijfsgegevens',
  'business.intro': 'Je salonnaam en adres staan op je boekingspagina en in bevestigingen.',
  'business.name': 'Naam van je salon',
  'business.postcode': 'Postcode',
  'business.houseNumber': 'Huisnummer',
  'business.street': 'Straat',
  'business.city': 'Plaats',
  'business.lookup': 'Adres opzoeken',
  'business.notFound': 'Adres niet gevonden. Vul het zelf in.',
  'business.phone': 'Telefoonnummer',
  'business.email': 'E-mailadres voor klanten',
  'business.legal': 'Voor facturen en je boekingspagina',
  'business.legalName': 'Officiële bedrijfsnaam (optioneel)',
  'business.kvk': 'KvK-nummer',
  'business.vat': 'Btw-nummer',
  'business.kor': 'Ik gebruik de kleineondernemersregeling (KOR)',
  'business.korHint': 'Dan rekenen je diensten geen btw en tonen we in je overzichten geen btw-bedragen.',
} as const;

export const setupEn: Record<keyof typeof setupNl, string> = {
  'common.save': 'Save',
  'common.saved': 'Saved',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.close': 'Close',
  'common.add': 'Add',
  'common.moreOptions': 'More options',
  'common.fewerOptions': 'Fewer options',
  'common.back': 'Salon',
  'common.minutes': 'min',
  'common.hour': 'h',
  'common.none': 'None',
  'common.loading': 'Loading…',
  'day.1': 'Monday',
  'day.2': 'Tuesday',
  'day.3': 'Wednesday',
  'day.4': 'Thursday',
  'day.5': 'Friday',
  'day.6': 'Saturday',
  'day.7': 'Sunday',
  'aside.services': 'How clients see your services',
  'aside.offline': '{n} only in the calendar, not bookable online',
  'aside.offlineOne': '1 only in the calendar, not bookable online',
  'aside.from': 'from',
  'aside.hours': 'How it shows on your booking page',
  'aside.closures': 'Coming closures',
  'aside.noClosures': 'No closures planned.',
  'aside.booking': 'How your booking page looks',
  'aside.bookingOff': 'Online booking is off. Clients see your phone number here.',
  'aside.who': 'With whom?',
  'aside.anyone': "Doesn't matter",
  'aside.email': 'How the email looks',
  'aside.business': 'How clients see your details',
  'aside.onBooking': 'On your booking page',
  'aside.inEmails': 'Below every email',
  'aside.teamWeek': 'This week',
  'aside.teamWeekHint': "Everyone's working hours, as they are in the calendar.",
  'aside.help': 'Good to know',
  'aside.read': 'Read more',
  'hours.open': 'Open',
  'hours.closed': 'Closed',
  'hours.notWorking': 'Off',
  'hours.addBlock': 'Add time block',
  'hours.removeBlock': 'Remove time block',
  'hours.copyToWeekdays': 'Copy to all open days',
  'hoursPage.title': 'Opening hours',
  'hoursPage.intro': 'When your salon is open. Clients can only book online within these hours.',
  'hoursPage.holidays': 'Public holidays',
  'hoursPage.holidaysIntro': 'Switch on the holidays you are closed on. This applies every year.',
  'hoursPage.closedOn': 'Closed',
  'hoursPage.closures': 'Closed days',
  'hoursPage.closuresIntro': 'Holiday or renovation? Clients see your message on your booking page.',
  'hoursPage.from': 'From',
  'hoursPage.until': 'Until and including',
  'hoursPage.message': 'Message for clients (optional)',
  'hoursPage.messagePlaceholder': "We're on holiday",
  'hoursPage.noClosures': 'No closed days planned.',
  'services.title': 'Services',
  'services.intro': 'What clients can book with you, with duration and price.',
  'services.empty.title': 'No services yet',
  'services.empty.body': 'Start with an example menu for your type of business and adjust it, or create your first service yourself.',
  'services.useTemplate': 'Use example services',
  'services.startEmpty': 'Start from scratch',
  'services.newService': 'Service',
  'services.newCategory': 'Category',
  'services.categoryName': 'Category name',
  'services.renameCategory': 'Edit category',
  'services.editCategory': 'Edit',
  'services.deleteCategory': 'Delete category',
  'services.deleteCategoryConfirm': 'Are you sure? The services in this category are deleted too. Existing appointments stay.',
  'services.from': 'from',
  'services.variants': '{n} variants',
  'services.variant1': '1 variant',
  'service.defaultVariant': 'Standard',
  'services.notOnline': 'not online',
  'service.new': 'New service',
  'service.edit': 'Edit service',
  'service.name': 'Name',
  'service.category': 'Category',
  'service.duration': 'Duration',
  'service.price': 'Price',
  'service.priceHint': 'Including VAT, as clients see it.',
  'service.fromPrice': '"From" price',
  'service.fromPriceHint': 'Clients see "from € …", for example when the price depends on hair length.',
  'service.description': 'Description for clients',
  'service.processing': 'Processing time',
  'service.processingHint': "During processing time you're free for another client, for example while colour develops.",
  'service.before': 'Work first',
  'service.wait': 'Processing',
  'service.after': 'Then work',
  'service.cleanup': 'Cleaning time afterwards',
  'service.cleanupHint': "Time to tidy up. Clients don't see it, but nothing is booked straight after.",
  'service.variants': 'Variants',
  'service.variantsHint': 'For example short, medium or long hair, each with its own duration and price. The client picks one.',
  'service.addVariant': 'Add variant',
  'service.variantName': 'Variant name',
  'service.who': 'Who can do this',
  'service.everyone': 'Everyone',
  'service.online': 'Bookable online',
  'service.onlineHint': 'Off: only you and your team can schedule it.',
  'service.vat': 'VAT rate',
  'service.vatHint': 'Only for your reports. Hairdressers and barbers: 9%. Nails, beauty, pedicure, massage: 21%.',
  'service.delete': 'Delete service',
  'service.deleteConfirm': 'Delete service? Existing appointments stay.',
  'team.title': 'Team',
  'team.intro': 'Who works with you, when, and what they can do.',
  'team.add': 'Add team member',
  'team.followsHours': 'Follows opening hours',
  'team.ownHours': 'Own working hours',
  'team.owner': 'Owner',
  'team.manager': 'Manager',
  'team.staff': 'Staff',
  'team.noLogin': 'No app access',
  'member.new': 'New team member',
  'member.name': 'Name',
  'member.nameHint': 'This is how clients see this person on your booking page.',
  'member.color': 'Calendar colour',
  'member.online': 'Bookable online',
  'member.onlineHint': "Off: clients can't choose this person online and they aren't assigned automatically.",
  'member.services': 'Services',
  'member.allServices': 'All services',
  'member.hours': 'Working hours',
  'member.hoursFollow': 'Works when the salon is open',
  'member.hoursOwn': 'Own working hours',
  'member.blocked': 'Blocked time',
  'member.blockedIntro': "Break, day off, sick or holiday. This time can't be booked online.",
  'member.noBlocks': 'No blocked time planned.',
  'member.sickToday': 'Report sick for today',
  'member.delete': 'Delete team member',
  'member.deleteConfirm': 'Delete team member? Existing appointments stay.',
  'block.add': 'Block time',
  'block.date': 'Date',
  'block.allDay': 'All day',
  'block.from': 'From',
  'block.until': 'Until',
  'block.reason': 'Reason',
  'block.repeat': 'Repeat',
  'block.repeatNone': 'No',
  'block.repeatDaily': 'Every day',
  'block.repeatWeekly': 'Every week',
  'block.repeatUntil': 'Repeat until and including',
  'reason.pause': 'Break',
  'reason.day_off': 'Day off',
  'reason.sick': 'Sick',
  'reason.vacation': 'Holiday',
  'reason.meeting': 'Meeting',
  'reason.other': 'Other',
  'business.title': 'Business details',
  'business.intro': 'Your salon name and address appear on your booking page and in confirmations.',
  'business.name': 'Salon name',
  'business.postcode': 'Postcode',
  'business.houseNumber': 'House number',
  'business.street': 'Street',
  'business.city': 'City',
  'business.lookup': 'Look up address',
  'business.notFound': 'Address not found. Please fill it in yourself.',
  'business.phone': 'Phone number',
  'business.email': 'Email address for clients',
  'business.legal': 'For invoices and your booking page',
  'business.legalName': 'Registered business name (optional)',
  'business.kvk': 'KvK number',
  'business.vat': 'VAT number',
  'business.kor': 'I use the small business scheme (KOR)',
  'business.korHint': "Then your services carry no VAT and we don't show VAT amounts in your reports.",
};
